import React, { memo } from 'react'
import classNames from 'classnames'
import { Skeleton } from 'transfix-ui/core'
import { TAG_SIZE, TAG_STYLE } from './TagTypes'
import 'scss/5_components/_dpl-tag.scss'

export interface ITagProps {
  label: string | JSX.Element
  icon?: JSX.Element
  size?: TAG_SIZE
  tagStyle?: TAG_STYLE
  textStyle?: string
  dataTooltip?: string
  outlineOnly?: boolean
  className?: string
  dataTest?: string
  /**
   * Set to true to render a Skeleton component in place of the tag. Indicates
   * that the tag is waiting to receive some data before rendering.
   */
  loading?: boolean
  style?: {
    [key: string]: string
  }
}

export const Tag = memo<ITagProps>(
  ({
    size = TAG_SIZE.medium,
    tagStyle = TAG_STYLE.dark,
    className = '',
    dataTest = '',
    textStyle = '',
    label,
    icon,
    dataTooltip,
    outlineOnly,
    style,
    loading,
  }) => {
    return loading ? (
      <Skeleton className='dpl-tag' variant='rectangular' height={32} width={100} />
    ) : (
      <span
        className={classNames(`dpl-tag dpl-tag-${size} dpl-tag-${tagStyle}`, className, {
          'dpl-tag-outline': outlineOnly,
        })}
        style={style}
        data-tooltip={dataTooltip}
        data-test={dataTest}>
        {icon ? (
          <span className='flex items-center'>
            <span className='mt1'>{icon}</span>
            {label && <span className={`ml2 ${textStyle}`}>{label}</span>}
          </span>
        ) : (
          <span className={textStyle}>{label}</span>
        )}
      </span>
    )
  }
)

export default Tag
